var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { BlocksElement } from '../../BlocksElement';
import styles from '../icon.styles';
/**
 * LocationFilled Icon component
 * @csspart base- The component's base wrapper
 */
export class BlocksIconLocationFilled extends BlocksElement {
    static { this.styles = styles; }
    connectedCallback() {
        super.connectedCallback();
        this.classList.add('cat-icon');
    }
    render() {
        const componentClassName = this.componentClassNames('cat-c-icon', {
            'cat-c-icon--sm': this.size === 'sm',
            'cat-c-icon--lg': this.size === 'lg',
            'cat-c-icon--xl': this.size === 'xl',
            'cat-c-icon--content-strong': this.color === 'content-strong',
            'cat-c-icon--knockout': this.color === 'knockout',
            'cat-c-icon--knockout-brand': this.color === 'knockout-brand',
            'cat-c-icon--information': this.color === 'information',
            'cat-c-icon--success': this.color === 'success',
            'cat-c-icon--warning': this.color === 'warning',
            'cat-c-icon--error': this.color === 'error'
        });
        return html `
      <span part="base" class="${componentClassName}" role="presentation">
        <svg
          aria-hidden="${!this.iconTitle}"
          aria-label="${ifDefined(this.iconTitle)}"
          role="${this.iconTitle && 'img'}"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M12.0055 22.0926C11.3831 22.5586 11.383 22.5585 11.3829 22.5583L11.3815 22.5565L11.3773 22.5509L11.3615 22.5297L11.3015 22.4485C11.2491 22.3778 11.1728 22.2739 11.076 22.1408C10.8823 21.8744 10.6062 21.4905 10.2753 21.0179C9.61382 20.0734 8.73055 18.7717 7.846 17.3456C6.96309 15.9222 6.07019 14.361 5.39546 12.8998C4.73446 11.4684 4.23047 10.0252 4.23047 8.8751C4.23047 6.81304 5.04961 4.83544 6.50772 3.37735C7.96581 1.91925 9.94341 1.1001 12.0055 1.1001C14.0675 1.1001 16.0451 1.91925 17.5032 3.37735C18.9613 4.83544 19.7805 6.81304 19.7805 8.8751C19.7805 10.0252 19.2765 11.4684 18.6155 12.8998C17.9407 14.361 17.0479 15.9222 16.1649 17.3456C15.2804 18.7717 14.3971 20.0734 13.7357 21.0179C13.4047 21.4905 13.1286 21.8744 12.935 22.1408C12.8381 22.2739 12.7618 22.3778 12.7095 22.4485L12.6494 22.5297L12.6336 22.5509L12.6295 22.5565L12.6283 22.5579C12.6282 22.558 12.6278 22.5586 12.0055 22.0926ZM12.0055 22.0926L12.6283 22.5579C12.4815 22.7539 12.2504 22.8701 12.0055 22.8701C11.7605 22.8701 11.5297 22.7544 11.3829 22.5583L12.0055 22.0926ZM14.5275 8.87505C14.5275 10.268 13.3983 11.3971 12.0054 11.3971C10.6125 11.3971 9.48334 10.268 9.48334 8.87505C9.48334 7.48214 10.6125 6.35297 12.0054 6.35297C13.3983 6.35297 14.5275 7.48214 14.5275 8.87505Z"
          />
        </svg>
      </span>
    `;
    }
}
__decorate([
    property({ type: String })
], BlocksIconLocationFilled.prototype, "color", void 0);
__decorate([
    property({ type: String })
], BlocksIconLocationFilled.prototype, "iconTitle", void 0);
__decorate([
    property({ type: String })
], BlocksIconLocationFilled.prototype, "size", void 0);
if (customElements.get('cat-icon-location-filled') === undefined) {
    customElements.define('cat-icon-location-filled', BlocksIconLocationFilled);
}
